import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";

const SkipInvoiceAndPaymentDialog = ({
  open,
  handleClose,
  onConfirm,
  loading,
}) => {
  const theme = useTheme();
  const [errorMsg, setErrorMessage] = useState(null);
  const [confirmText, setConfirmText] = useState(null);

  return (
    <Dialog
      keepMounted
      scroll={"paper"}
      maxWidth="sm"
      fullWidth={true}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Skip Invoice & Payment</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Please confirm you want to skip payment and move this order to
          In-Progress by entering "confirm". You can still add an invoice to
          this order later
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="confirm"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={() => {
            setConfirmText("");
            handleClose();
          }}
          loading={loading}
        >
          Back
        </LoadingButton>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={confirmText != "confirm"}
          onClick={onConfirm}
        >
          Skip
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default SkipInvoiceAndPaymentDialog;
